import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

interface IBaseStore {
  reset: () => void;
}

class StoreService {
  static useBaseStore = create<IBaseStore>()(
    devtools(
      subscribeWithSelector((set) => ({
        reset: () => set({}, false, 'reset'),
      })),
      { name: 'BaseStore' }
    )
  );

  static resetAllStores = () => {
    StoreService.useBaseStore.getState().reset();
  };
}

export default StoreService;